import router from './router'
import publicComplaintMessages from './localization'

export default {
  router,
  localization: publicComplaintMessages,
}
